import { Platform } from "react-native";

export default Platform.select({
  ios: "977085460082-nu14hoce9k8c6qm5mava33sd388qv70n.apps.googleusercontent.com",
  android:
    "977085460082-hho6sri0r0vjsmmkduf736joljcdcnfv.apps.googleusercontent.com",
  default:
    "977085460082-sh4lhun06hhf2foa412711euao2rf41n.apps.googleusercontent.com",
});
